export default __webpack_public_path__ + "static/media/logo.d9c1998f.png";